import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';
import { fetchStates } from '../../../../../Redux/Actions/CommonActions';

class OrganizationForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			disabled: false,
			organizationInEdit: this.props.dataItem || null,
			originalOrganization: this.props.dataItem || {},
			value: [],
			organizationMessage: '',
			isActive: false
		};
	}

	componentDidMount() {
		this.props.fetchStates();
		this.normalizeState();
	}

	normalizeState() {
		const state = {
			name: this.props.dataItem.State || '',
			id: this.props.dataItem.StateId || 0
		};
		const edited = this.state.organizationInEdit;
		edited.state = state;
		this.setState({
			organizationInEdit: edited
		});
	}

	handleSubmit = (event) => {
		event.preventDefault();

		if (this.state.disabled) {
			return;
		}
		this.setState({ disabled: true });

		this.props.save({
			...this.state.organizationInEdit
		});
	};

	onDialogInputChange = (event) => {
		const edited = this.state.organizationInEdit;
		edited[event.target.name] = event.target.value;

		this.setState({
			organizationInEdit: edited,
			organizationMessage: '',
			isActive: true
		});
	};

	handleState = (event) => {
		let target = event.target;
		
		const edited = this.state.organizationInEdit;
		// Update front-end state Object for DropDownList
		edited.state.name = target.value.name;
		edited.state.id = target.value.id;
		// Update State & StateId for Post SaveOrganization
		edited.State = target.value.name;
		edited.StateId = target.value.id;
		
		this.setState({
			organizationInEdit: edited,
			isActive: true
		});
	};

	handleZipChange = (event) => {
		var originalValue = this.state.organizationInEdit.Zip;
		const edited = this.state.organizationInEdit;
		var value = event.target.value.replace(/\D/g, '');;
		if ((value.match(/^[0-99999]|^$/) || value == "") && value.length <= 5) {
			edited.Zip = value;
			this.setState({
				organizationInEdit: edited,
				isActive: true
			});
		}
		else {
			edited.Zip = originalValue;
			this.setState({
				organizationInEdit: edited,
				isActive: true
			});
		}
	}


	render() {
		return (
			<Dialog onClose={this.props.cancel}>
				<h2 className="adjust-dist-title2">Edit Organization</h2>
				<form className="user-form user-form--org" onSubmit={this.handleSubmit}>

					<div className="form-group col-md-6">
						<label htmlFor="OrganizationName">Organization Name</label>
						<Input
							required={true}
							type="text"
							name="OrganizationName"
							id="OrganizationName"
							value={this.state.organizationInEdit.OrganizationName || ''}
							onChange={this.onDialogInputChange}
						/>
						<p className="error-message">{this.state.organizationMessage}</p>
					</div>

					<div className="form-group col-md-6">
						<label htmlFor="Address1">Address 1</label>
						<Input
							required={true}
							type="text"
							name="Address1"
							id="Address1"
							value={this.state.organizationInEdit.Address1 || ''}
							onChange={this.onDialogInputChange}
						/>
						<p className="error-message">{this.state.organizationMessage}</p>
					</div>

					<div className="form-group col-md-6">
						<label htmlFor="Address2">Address 2</label>
						<Input
							type="text"
							name="Address2"
							id="Address2"
							value={this.state.organizationInEdit.Address2 || ''}
							onChange={this.onDialogInputChange}
						/>
						<p className="error-message">{this.state.organizationMessage}</p>
					</div>

					<div className="form-group col-md-6">
						<label htmlFor="City">City</label>
						<Input
							required={true}
							type="text"
							name="City"
							id="City"
							value={this.state.organizationInEdit.City || ''}
							onChange={this.onDialogInputChange}
						/>
						<p className="error-message">{this.state.organizationMessage}</p>
					</div>

					<div className="form-group col-md-6">
						<label htmlFor="state">State</label>
						<DropDownList data={this.props.common.states}
							required={true}
							id="state"
							name="state"
							textField="name"
							dataItemKey="id"
							onChange={this.handleState}
							value={this.state.organizationInEdit.state}
						/>
						<p className="error-message">{this.state.organizationMessage}</p>
					</div>

					<div className="form-group col-md-6">
						<label htmlFor="Zip">Zip</label>
						<Input
							required={true}
							type="text"
							name="Zip"
							id="Zip"
							pattern="(\d{5}([\-]\d{4})?)"
							placeholder="12345"
							title="Zip Code (Format: 12345)"
							value={this.state.organizationInEdit.Zip || ''}
							onChange={this.handleZipChange}
						/>
						<p className="error-message">{this.state.organizationMessage}</p>
					</div>

					<DialogActionsBar>
						<div className="adjust-btns">
							<div className="form-group form-group--org">
								<button className="admin-k-button" onClick={this.props.cancel}>
									<i className="fas fa-times"></i>
									<span>CANCEL</span>
								</button>
								{!this.state.organizationInEdit.organizationOptionId ? (
									<button type="submit" className="admin-k-button" disabled={this.state.disabled || !this.state.isActive}>
										<i className="fas fa-save"></i>
										<span>{this.state.disabled ? 'SAVING...' : 'SAVE'}</span>
									</button>
								) : (
										<button type="submit" className="admin-k-button" disabled={this.state.disabled || !this.state.isActive}>
											<i className="fas fa-edit"></i>
											<span>{this.state.disabled ? 'UPDATING...' : 'UPDATE'}</span>
										</button>
									)}
							</div>
						</div>
					</DialogActionsBar>
				</form>
			</Dialog>
		);
	}
}

function mapStateToProps(state) {
	return {
		common: state.common
	};
}

export default withRouter(connect(mapStateToProps, {fetchStates})(OrganizationForm));
